import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { IOverlayProps, IOverlayStyleProps, IOverlayStyles } from '/druid/Overlay.types';
import { OverlayBase } from '/druid/Overlay.base';
import { getStyles } from '/druid/Overlay.styles';

export const Overlay: React.FunctionComponent<IOverlayProps> = styled<
  IOverlayProps,
  IOverlayStyleProps,
  IOverlayStyles
>(OverlayBase, getStyles, undefined, {
  scope: 'Overlay',
});
